import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import { TerminationReasonDto } from 'enrollment/queries/useBenefitPlansQuery/types';
import { ElectRequestDto } from 'enrollment/features/Plans/PlanCard/types/dtos';
import { PsSelectTuner, PsModalTuner } from 'stencilSetup';

export interface TerminationReasonModalProps {
  params?: ElectRequestDto;
  terminationReasons: TerminationReasonDto[];
  handleElectPlan: (params: ElectRequestDto) => void;
  modalOpen: boolean;
  setModalOpen: (value: boolean) => void;
}

declare const bootstrap: any;

export const TerminationReasonModal = ({
  params,
  terminationReasons,
  handleElectPlan,
  modalOpen,
  setModalOpen,
}: TerminationReasonModalProps) => {
  const [termReasonValue, setTermReasonValue] = useState('');

  const [terminationReasonId, setTerminationReasonId] = useState<
    number | undefined
  >(undefined);
  const { t } = useTranslation('enrollment.benefits');

  const handleTermReason = () => {
    if (terminationReasonId !== 0 && params) {
      handleElectPlan({
        ...params,
        termination_reason_id: terminationReasonId,
      });
      setModalOpen(false);
    }
  };

  const handleTermReasonChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setTerminationReasonId(Number(value));

      setTermReasonValue(value);
    }
  };

  const handleCloseModal = () => {
    setTerminationReasonId(0);
    setTermReasonValue('');
    setModalOpen(false);
  };

  useEffect(() => {
    if (modalOpen) {
      const modalElement = document.getElementById('termination-reason-modal');
      const hidden = modalElement?.getAttribute('aria-hidden');
      if (modalElement && hidden === 'true') {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }, [modalOpen]);

  if (
    !modalOpen ||
    !terminationReasons ||
    terminationReasons.length === 0 ||
    !params
  ) {
    return null;
  }

  return (
    <PsModalTuner
      data-testid="termination-reason-modal"
      modalId="termination-reason-modal"
      modalTitle={t('terminationReason')}
      primaryActive={true}
      primaryButton={t('common:confirm')}
      secondaryButton={t('common:cancel')}
      onPsModalDismiss={handleCloseModal}
      onPsModalSubmit={handleTermReason}
      disablePrimary={Boolean(
        !terminationReasonId || terminationReasonId === 0
      )}
    >
      <div id="termReason">
        <PsSelectTuner
          data-testid={`termination-reason-select-${params?.org_benefit_id}`}
          inputId={`termination-reason-select-${params?.org_benefit_id}`}
          label={t('terminationReason')}
          value={termReasonValue}
          onPsChange={(e) => handleTermReasonChange(e.detail.event)}
          onPsBlur={(e) => handleTermReasonChange(e.detail.event)}
          firstOption={t('selectTerminationReason')}
          required={true}
          validationText="Required"
        >
          {terminationReasons?.map((reason) => (
            <option
              value={reason.id}
              id={`${params?.org_benefit_id}-${reason.id}`}
              key={`${params?.org_benefit_id}-${reason.id}`}
            >
              {reason.name}
            </option>
          ))}
        </PsSelectTuner>
      </div>
    </PsModalTuner>
  );
};
